import {Component, OnDestroy, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Button} from 'primeng/button';
import {FloatLabel} from 'primeng/floatlabel';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {DialogAction} from '../../../../shared/contracts/dialog.interface';
import {Textarea} from 'primeng/textarea';

@Component({
  selector: 'app-template-dialog',
  standalone: true,
  imports: [
    Button,
    FloatLabel,
    ReactiveFormsModule,
    Textarea
  ],
  templateUrl: './template-dialog.component.html',
  styleUrl: './template-dialog.component.scss'
})
export class TemplateDialogComponent implements OnInit, OnDestroy {
  static readonly DIALOG_CONFIG: DynamicDialogConfig = {
    header: 'Dati Template',
    width: '95vw',
    style: {'max-width': '800px'},
    modal: true,
    focusOnShow: false,
  };

  templateForm: FormGroup;

  private initForm(): FormGroup {
    return this.fb.group({
      text: ['', Validators.required],
    });
  }

  constructor(private fb: FormBuilder, private ref: DynamicDialogRef, private config: DynamicDialogConfig) {
    this.templateForm = this.initForm();
  }


  save() {
    // Get form values
    let templateData = { ...this.templateForm.value };

    this.ref.close({
      action: DialogAction.OK,
      data: templateData
    });
  }

  ngOnInit() {
    if (this.config.data) {
      this.templateForm.patchValue({...this.config.data})
    }
  }

  closeDialog(){
    this.ref.close({
      action: DialogAction.CLOSE,
    });
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
